module.exports = __webpack_public_path__ + "static/img/patent_4.8a104708.png";